// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3zQWy","selects":"Documents_selects__3F6O_"};